import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from "@ngx-translate/core";
import { MatButtonModule } from "@angular/material/button";
import { ChoiceDialogData } from "../ConfirmDialogDatas";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

@Component({
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, TranslateModule, MatRadioModule, CommonModule, FormsModule],
    templateUrl: './choice-dialog.component.html',
    styleUrls: ['./choice-dialog.component.scss']
})
export class ChoiceDialogComponent {
  selected: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ChoiceDialogData) {
    this.selected = data.defaultValue;
  }
}
